var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-sheet',{staticClass:"mx-auto",class:_vm.customClass,staticStyle:{"width":"100% !important"},style:(_vm.variantWidth(_vm.variant)),attrs:{"color":_vm.color}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }